<template>
  <EInstantAnswer
    class="notice"
    data-test-id="ad-block-notice"
    :feedback-link="feedbackLinkProps"
  >
    <div class="notice__layout">
      <div class="notice__content">
        <EHeading as="h2">
          {{ $t("web.adblock.title") }}
        </EHeading>
        <p class="notice__text">
          {{ $t("web.adblock.text") }}
        </p>
        <EButton
          as="a"
          variant="outline"
          size="m"
          target="_blank"
          href="https://ecosia.zendesk.com/hc/articles/115005207705"
        >
          {{ $t("web.adblock.cta") }}
        </EButton>
      </div>
      <img
        class="notice__graphic"
        :src="graphicPath"
        loading="lazy"
        aria-hidden="true"
      >
    </div>
  </EInstantAnswer>
</template>

<script>
import EButton from '~~/common/vue/components/button';
import EInstantAnswer from '~/components/instant-answers/base';
import EHeading from '~~/common/vue/components/heading';
import { sendEvent } from '~~/common/js/client/analytics';
import graphicPath from '~~/common/vue/assets/images/hand-plant.as-path.svg';
import { HELPSCOUT_AD_BLOCKING } from '~~/common/js/constants/urls';

export default {
  name: 'EAdBlockNotice',
  components: {
    EButton,
    EInstantAnswer,
    EHeading,
  },
  computed: {
    feedbackLinkProps() {
      return {
        errorMessage: this.$t('common.header.feedback.error'),
        options: [
          { label: this.$t('common.header.feedback.bullet1'), value: 'helpful' },
          { label: this.$t('common.header.feedback.bullet2'), value: 'missing' },
          { label: this.$t('common.header.feedback.bullet3'), value: 'wrong' },
          { label: this.$t('common.header.feedback.bullet4'), value: 'not_helpful' },
        ],
        query: this.$route ? this.$route.query?.q?.toString() : '',
        submitText: this.$t('common.header.feedback.send'),
        successMessage: this.$t('common.header.feedback.body2'),
        successTitle: this.$t('common.header.feedback.title2'),
        textareaPlaceholder: this.$t('common.header.feedback.tellmore'),
        title: this.$t('common.header.feedback.login'),
        ticketSubject: 'Search - Ad blocker notice',
        url: process.env.feedbackUrl,
        widgetType: 'adblock_notice',
      };
    },
    disableAdBlockerUrl() {
      return HELPSCOUT_AD_BLOCKING;
    },
    graphicPath() {
      return graphicPath;
    },
  },
  mounted() {
    sendEvent(
      'search_adblocknotice_impression',
      'new_version', // As opposed to the old stack
    );
  },
};
</script>
<style lang="scss" scoped>
.notice {
  @include desktop-down {
    display: none;
  }
}

.notice__layout {
  align-items: center;
  display: flex;
}

.notice__text {
  margin: $space-m 0;
}

.notice__graphic {
  flex-shrink: 0;
  margin-left: $space-m;
}
</style>
